"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkData = exports.css = exports.props = void 0;
// @ts-ignore
var imageClientSDK_1 = __importDefault(require("image-client-api/dist/imageClientSDK")); // eslint-disable-line no-restricted-syntax
var withCompInfo_1 = require("../../core/withCompInfo");
// @ts-ignore
var CLASSIC_LAYOUT = 'classic';
var DEFAULT_ICON_ID = 'icon0';
var MAX_COVER_SIZE = 140;
var COVER_TRANSFORM_TYPE = { transformType: 'fit', quality: 90 };
var FALLBACK_COVER_URI = 'f9a47e_a45ee66e0d00442cbdbfcc323bb135d8.svg';
var SOURCE = { UPLOADS: 'uploads', URL: 'url' };
var staticAudioUrl = 'https://music.wixstatic.com/mp3'; // TODO add to topology
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'isMobileView', 'topology'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, isMobileView = _a.isMobileView, topology = _a.topology;
    var iconId = compProps.iconId || DEFAULT_ICON_ID; // TODO fix iconId type in MusicPlayerProperties
    return {
        displayTime: isMobileView ? 'remaining' : 'full',
        isClassicLayout: compProps.layout === CLASSIC_LAYOUT,
        showCover: compProps.showCover,
        showArtistName: compProps.showArtistName,
        showTrackName: compProps.showTrackName,
        showProgressBar: compProps.showProgressBar,
        showTimeStamp: compProps.showTimeStamp,
        loop: compProps.loop,
        iconId: iconId,
        playlist: [
            {
                artistName: compData.artistName,
                trackName: compData.trackName,
                cover: getCoverUrl(compData),
                url: getAudioUrl(compData, compProps),
            },
        ],
        duration: compData.audioRef && compData.audioRef.duration,
        fallbackCover: topology.mediaRootUrl + "shapes/" + FALLBACK_COVER_URI,
        playClassName: playClassNames[iconId] || 'oneColor',
        pauseClassName: pauseClassNames[iconId] || 'oneColor',
    };
});
exports.css = withCompInfo_1.withCompInfo(['hasResponsiveLayout', 'compProps', 'compLayout'], function (_a) {
    var hasResponsiveLayout = _a.hasResponsiveLayout, compProps = _a.compProps, compLayout = _a.compLayout;
    if (hasResponsiveLayout) {
        return {};
    }
    if (compProps.layout === CLASSIC_LAYOUT) {
        return { height: 'auto' };
    }
    return { height: compLayout.width + "px" };
});
exports.sdkData = withCompInfo_1.withCompInfo(['compData', 'compProps'], function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var compData = _a.compData, compProps = _a.compProps;
    var audioData = compProps.source === SOURCE.URL && compData.audioUrl
        ? { uri: compData.audioUrl, title: '' }
        : {
            uri: ((_b = compData.audioRef) === null || _b === void 0 ? void 0 : _b.uri) || '',
            title: ((_c = compData.audioRef) === null || _c === void 0 ? void 0 : _c.title) || '',
        };
    var coverData = compData.coverUrl
        ? { uri: compData.coverUrl, title: '', width: 0, height: 0 }
        : {
            title: (_d = compData.coverRef) === null || _d === void 0 ? void 0 : _d.title,
            uri: (_e = compData.coverRef) === null || _e === void 0 ? void 0 : _e.uri,
            width: (_f = compData.coverRef) === null || _f === void 0 ? void 0 : _f.width,
            height: (_g = compData.coverRef) === null || _g === void 0 ? void 0 : _g.height,
        };
    return {
        audioData: audioData,
        coverData: coverData,
    };
});
function getCoverUrl(compData) {
    var coverUrl = compData.coverUrl;
    if (coverUrl) {
        return coverUrl;
    }
    var coverRef = compData.coverRef;
    if (!coverRef || typeof coverRef !== 'object') {
        return undefined;
    }
    return imageClientSDK_1.default.getScaleToFillImageURL(coverRef.uri, coverRef.width, coverRef.height, MAX_COVER_SIZE, MAX_COVER_SIZE, COVER_TRANSFORM_TYPE);
}
function getAudioUrl(compData, compProps) {
    if (compProps.source === SOURCE.URL) {
        var audioUrl = compData.audioUrl;
        if (audioUrl) {
            return audioUrl;
        }
    }
    var audioRef = compData.audioRef;
    if (audioRef) {
        return staticAudioUrl + "/" + audioRef.uri;
    }
    return '';
}
var playClassNames = {
    icon8: 'twoColors',
    icon9: 'twoColors',
    icon10: 'twoColors',
    icon11: 'twoColors',
    icon15: 'twoColors',
    icon16: 'twoColors',
    icon17: 'twoColors',
    icon18: 'twoColors',
    icon19: 'twoColors',
    icon20: 'twoColors',
};
var pauseClassNames = {
    icon2: 'oneColorPause',
    icon4: 'oneColorPause',
    icon5: 'oneColorPause',
    icon8: 'twoColors',
    icon9: 'twoColors',
    icon10: 'twoColors',
    icon11: 'twoColors',
    icon12: 'oneColorPause',
    icon15: 'twoColors',
    icon16: 'twoColors',
    icon17: 'twoColors',
    icon18: 'twoColors',
    icon19: 'twoColors',
    icon20: 'twoColors',
    icon23: 'oneColorPause',
};
//# sourceMappingURL=MusicPlayer.js.map